export const metricData = {
  qInfo: { qType: "pivothypercube" },
  qHyperCubeDef: {
    qDimensions: [
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["SchoolName_SchoolProfiles"],
          qFieldLabels: ["School Name"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["domain"],
          qFieldLabels: ["Domain"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["metric_ui"],
          qFieldLabels: ["Metric"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["exception"],
          qFieldLabels: ["Exception"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        }
      },
      {
        qLibraryId: "",
        qDef: {
          qFieldDefs: ["report"],
          qFieldLabels: ["Report Type"],
        }
      }
    ],
    qMeasures: [
      { qDef: { qLabel: "Target", qDef: "target" } },
      { qDef: { qLabel: "Floor", qDef: "floor" } },
      { qDef: { qLabel: "Numerator", qDef: "num" } },
      { qDef: { qLabel: "Denominator", qDef: "denom" } },
      { qDef: { qLabel: "Points Possible", qDef: "p.pts_poss" } },
      { qDef: { qLabel: "Points Earned", qDef: "pts_earned" } },
      { qDef: { qLabel: "Score", qDef: "p.score" } },
      { qDef: { qLabel: "SortOrder", qDef: "domainsort" } },
      { qDef: { qLabel: "Percent Earned", qDef: "pct_earned" } }

    ]
  }
};
